

const alertDone = () => {
  alert('완료 되었습니다. ')
}

const alertDelete = () => {
  const result = window.confirm('삭제 하시겠습니까?');
  return result;
}


export {alertDone, alertDelete};